export default {
  'menu.pages': 'Seiten',
  'menu.features': 'Funktionen',
  'menu.tenants': 'Mandanten',
  'menu.subscriptions': 'Abonnements',
  'menu.adminMarketplace': 'Marktplatz',
  'menu.adminMarketplaceFeatures': 'Feature-Marktplatz',
  'menu.schedulers': 'Planer',
  'menu.dashboard': 'Dashboard',
  'menu.home': 'Start',
  'menu.roles': 'Rollen',
  'menu.profile': 'Profil',
  'menu.management': 'Verwaltung',
  'menu.logout': 'Abmelden',
  'menu.credits': 'Guthaben',
  'menu.revenue': 'Einnahmen',
  'menu.entitlements': 'Berechtigungen',
};
